<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl"
        :name="tableName"
        ref="datatable"
        :columns="columns"
        :options="options"
    )
        template(slot="beforeTable")
            datatable-loader(:name="tableName")

    subsidy-recovery-import-modal(
        ref="importModal"
        @import-success="refreshTable"
    )
</template>

<script>
import { mapState } from 'vuex';
import dateFormatMixin from '../../../mixins/date-format';
import tillFilterMixin from '../../../components/till-filter/till-filter-mixin';
import SubsidyRecoveryImportModal from './subsidy-recovery-import-modal.vue';

const TableName = 'SUBSIDY_RECOVERY_LIST';

export default {
    components: {
        SubsidyRecoveryImportModal,
    },

    mixins: [dateFormatMixin, tillFilterMixin],

    data() {
        return {
            tableName: TableName,
            columns: [
                'outlet_code',
                'outlet_name',
                'receipt_number',
                'receipt_date',
                'volume_litre',
            ],
            options: {
                useReportFilter: true,
                texts: {
                    title: 'Subsidy Recovery',
                    description: 'Subsidy recovery records by receipt date',
                    filterPlaceholder: 'Search receipt number',
                },
                customFilters: ['outlet_id', 'since', 'until', 'filters'],
                initFilters: {
                    outlet_id: this.$store.getters.activeOutlet,
                    since: this.$store.getters.startDate.format(),
                    until: this.$store.getters.endDate.format(),
                },
                headings: {
                    outlet_code: 'Outlet Code',
                    outlet_name: 'Outlet Name',
                    receipt_number: 'Receipt Number',
                    receipt_date: 'Receipt Date',
                    volume_litre: 'Volume (Litre)',
                },
                columnsClasses: {
                    outlet_code: 'text-center',
                    outlet_name: 'text-left',
                    receipt_number: 'text-center',
                    receipt_date: 'text-center',
                    volume_litre: 'text-right',
                },
                templates: {
                    receipt_date: (h, row) => {
                        return row.receipt_date
                            ? this.dateFormat(row.receipt_date)
                            : '';
                    },
                    volume_litre: (h, row) => {
                        if (
                            row.volume_litre === null ||
                            row.volume_litre === undefined
                        ) {
                            return '';
                        }
                        return Number(row.volume_litre).toFixed(3);
                    },
                },
                orderBy: {
                    column: 'receipt_date',
                    ascending: 0,
                },
                sortable: ['receipt_date', 'volume_litre'],
                actionButtons: [
                    {
                        title: 'Import',
                        action: () => {
                            this.openImport();
                        },
                    },
                ],
                responseAdapter: response => {
                    const payload =
                        response && response.data ? response.data : {};
                    return {
                        data: payload.data || [],
                        count: payload.count || 0,
                    };
                },
            },
        };
    },

    computed: {
        ...mapState('tillFilter', ['filters']),
        datatableUrl() {
            const route =
                typeof Laroute !== 'undefined' &&
                Laroute.route('franchise.report.subsidy-recovery.list');

            return route || '/franchise/report/subsidy-recovery/list';
        },
    },

    watch: {
        filters: function(to, from) {
            if (to === from) return;
            this.setFilter();
        },
    },

    methods: {
        openImport() {
            this.$refs.importModal.open();
        },

        refreshTable() {
            this.$refs.datatable.refresh();
        },

        setFilter() {
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'filters',
                value: this.filters,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/subsidy-recovery/subsidy-recovery.vue